/* eslint-disable quotes */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Table,
  Col,
  Row,
  Select,
  Form,
  Spin,
  Input,
  Button,
  message,
} from "antd";
import axios from "axios";
import { APIs } from "../../../../utils/worker";
import { capitalize } from "../../../../utils";

import "./style.scss";

const AddNewRoute = ({ handleCreateRoute, handleCloseModal, primaryMode }) => {
  const formLayout = "vertical";
  const [form] = Form.useForm();
  const { Option } = Select;

  const transitTimeOptions = [
    { label: 24, value: 24 },
    { label: 48, value: 48 },
    { label: 72, value: 72 },
    { label: 96, value: 96 },
  ];
  const transitMode = [
    { label: "Surface", value: "SURFACE" },
    { label: "Air", value: "AIR" },
  ];
  const options = [];
  const [transitForm, setTransitForm] = useState([]);
  const [hubDetails, setHubDetails] = useState([]);
  const [totalTAT, setTotalTAT] = useState(0);
  const [hubDetailsParent, setHubDetailsParent] = useState([]);
  const [originHub, setOriginHub] = useState("");
  const [destinationHub, setDestinationHub] = useState("");
  const [tokenData, setToken] = useState("");
  const [transitValue, settransitValue] = useState(0);
  const [test, setTest] = useState(false);

  useEffect(() => {
    let userData = JSON.parse(localStorage.getItem("userinfo"));
    getHubDetails(userData.accessToken);
    setToken(userData.accessToken);
  }, []);
  useEffect(() => {}, [transitValue]);

  const getHubDetails = async (token) => {
    let response = await axios.get(
      APIs.baseURL + "/premise-service/v1/premises",
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    let temp = [];
    response.data.map((item) => {
      temp.push({
        label: capitalize(item.premiseName),
        value: item.premiseId,
      });
    });
    setHubDetails(temp);
    setHubDetailsParent(temp);
  };

  const formProps = {
    name: "address",
    className: "register-form",
    onFinish: (values) => handleCreateRoute(values, transitForm),
    autoComplete: "off",
  };

  const handleSelectChange = (value, name) => {
    if (name === "destinationHub") {
      setDestinationHub(value);
      for (let i = 0; i < transitForm.length; i++) {
        form.setFieldValue("transitHub" + i, null);
        form.setFieldValue("transitTime" + i, null);
        form.setFieldValue("totalTAT", null);
      }
    } else if (name === "originHub") {
      form.setFieldValue("destinationHub", null);
      form.setFieldValue("destinationTransitTime", null);
      form.setFieldValue("totalTAT", null);
      setOriginHub(value);
      for (let i = 0; i < transitForm.length; i++) {
        form.setFieldValue("transitHub" + i, null);
        form.setFieldValue("transitTime" + i, null);
      }
    }

    if (name === "destinationTransitTime") {
      let total = 0;
      transitForm.map((e) => {
        total = total + +e.time;
      });
      setTotalTAT(total + value);
      form.setFieldValue("totalTAT", total + value);
    }
  };
  const onChange = (value) => {
    // console.log(`selected ${value}`);
  };

  const changeTransitValue = (e) => {
    for (let i = 0; i < transitForm.length; i++) {
      form.setFieldValue("transitHub" + i, null);
      form.setFieldValue("transitTime" + i, null);
      form.setFieldValue("destinationTransitTime", null);
      form.setFieldValue("totalTAT", null);
    }
    let value = e.target.value;
    if (value > 7) {
      settransitValue(7);
    } else {
      settransitValue(value);
      let transitForm_ = [];
      for (let i = 0; i < value; i++) {
        transitForm_.push({
          hub: "",
          time: "",
          mode: primaryMode === "SURFACE" ? "SURFACE" : "AIR",
        });
      }
      setTransitForm([...transitForm_]);
      setTest(!test);
    }
  };

  const changeTransit = async (data, index, name, nameVal) => {
    let transitForm_ = transitForm;
    form.setFieldsValue(nameVal, data);
    transitForm_[index] = { ...transitForm_[index], [name]: data };
    setTransitForm([...transitForm_]);
    // if (name === "mode") {
    //   let payload = {
    //     fromPremiseId: index === 0 ? originHub : transitForm[index - 1].hub,
    //     toPremiseId: transitForm[index].hub,
    //     mode: data,
    //   };
    //   let response = await axios.post(
    //     "https://smcs-dev.hutechweb.com/smcs-webapp/tat-service/v1/tat/mm-tat",
    //     payload,
    //     {
    //       headers: {
    //         Authorization: "Bearer " + tokenData,
    //         token: tokenData,
    //       },
    //     }
    //   );
    //}
    let destinationTime =
      form.getFieldValue("destinationTransitTime") !== undefined
        ? form.getFieldValue("destinationTransitTime")
        : 0;
    let total = 0;
    transitForm_.map((e) => {
      total = total + +e.time;
    });
    setTotalTAT(total + destinationTime);
    form.setFieldValue("totalTAT", total + destinationTime);
  };

  const onSearch = (e) => {
    // console.log(e);
  };

  const transitData = () => {
    let design = [];
    transitForm.map((item, index) => {
      let random = Math.random();
      design.push(
        <Row className="global-form-row" gutter={20} key={index}>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <Form.Item
              name={"transitHub" + index}
              label={"Transit " + (index + 1)}
              // initialValue={item.hub ? item.hub : "Select transit hub"}
              rules={[
                {
                  required: true,
                  message: "Please select transit hub",
                },
              ]}
            >
              <Select
                showSearch
                onSearch={onSearch}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                placeholder="Select transit hub"
                options={hubDetails.filter(
                  (e) => e.value !== originHub && e.value !== destinationHub
                )}
                onChange={(data) =>
                  changeTransit(data, index, "hub", "transitHub" + index)
                }
                value={item.hub}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <Form.Item
              name={`transitMode${index}`}
              label={
                index === 0
                  ? "Origin to T" + (index + 1) + " Mode"
                  : "T" + index + " to " + "T" + (index + 1) + " Mode"
              }
              initialValue={primaryMode}
              rules={[
                {
                  required: true,
                  message: "Please select mode",
                },
              ]}
            >
              <Select
                placeholder="Select mode"
                disabled={primaryMode === "AIR" ? false : true}
                options={transitMode}
                onChange={(data) =>
                  changeTransit(data, index, "mode", `transitMode${index}`)
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <Form.Item
              name={`transitTime${index}`}
              label={
                index === 0
                  ? "Origin to T" + (index + 1) + " TAT"
                  : "T" + index + " to " + "T" + (index + 1) + " TAT"
              }
              rules={[
                {
                  required: true,
                  message: "Please select time",
                },
              ]}
            >
              <Select
                placeholder="Select time"
                options={transitTimeOptions}
                onChange={(data) =>
                  changeTransit(data, index, "time", "transitTime" + index)
                }
              />
            </Form.Item>
          </Col>
        </Row>
      );
    });
    return design;
  };

  return (
    <div>
      <Spin spinning={false}>
        <Form
          {...formProps}
          form={form}
          layout={formLayout}
          className="route-table global-form"
        >
          <Row className={"global-form-row route-main"} gutter={20}>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name="originHub"
                label="Origin Hub"
                rules={[
                  {
                    required: true,
                    message: "Please select origin hub",
                  },
                ]}
              >
                <Select
                  showSearch
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  placeholder="Select origin hub"
                  options={hubDetails}
                  onChange={(value) => handleSelectChange(value, "originHub")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name="destinationHub"
                label="Destination Hub"
                rules={[
                  {
                    required: true,
                    message: "Please select destination hub",
                  },
                ]}
              >
                <Select
                  showSearch
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  placeholder="Select destination hub"
                  options={hubDetails}
                  onChange={(value) =>
                    handleSelectChange(value, "destinationHub")
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}></Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name="primaryMode"
                label="Primary mode of travel"
                rules={[
                  {
                    required: true,
                    message: "Please select mode",
                  },
                ]}
                initialValue={primaryMode}
              >
                <Select
                  className="disable-input"
                  disabled
                  placeholder="Select mode"
                  options={transitMode}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
              <Form.Item name="noOfTransit" label="Add Transit">
                <Input
                  placeholder="0"
                  onChange={changeTransitValue}
                  value={transitValue}
                  onKeyPress={(e) => {
                    if (/[^0-7]/.test(e.key) || e.target.value.length === 1) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={13}></Col>
          </Row>
          {transitData()}
          <Row gutter={20} className="global-form-row">
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item name="destinationHub" label="Destination Hub">
                <Select
                  placeholder="Select destination hub"
                  options={hubDetails}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name={`destinationTransitMode`}
                label={
                  transitForm.length > 0
                    ? "T" + transitForm.length + " to Destination Mode"
                    : "Origin to Destination Mode"
                }
                rules={[
                  {
                    required: true,
                    message: "Please select mode",
                  },
                ]}
                initialValue={primaryMode}
              >
                <Select
                  placeholder="Select mode"
                  disabled={primaryMode === "SURFACE" && true}
                  options={transitMode}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name={`destinationTransitTime`}
                label={
                  transitForm.length > 0
                    ? "T" + transitForm.length + " to Destination TAT"
                    : "Origin to Destination TAT"
                }
                rules={[
                  {
                    required: true,
                    message: "Please select time",
                  },
                ]}
              >
                <Select
                  placeholder="Select time"
                  options={transitTimeOptions}
                  onChange={(value) =>
                    handleSelectChange(value, "destinationTransitTime")
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item name="totalTAT" label="Total TAT" initialValue={0}>
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <hr className="divider mt-3" />
          <div className="d-flex flex-end" style={{ padding: "1rem 0 0 0" }}>
            <Button className="cancel-btn" onClick={handleCloseModal}>
              CANCEL
            </Button>
            <Button htmlType="submit" className="save-btn ml-1">
              SAVE
            </Button>
          </div>
          {/* <Row className="add-pin-footer">
            <Button className="btn-style cancel-btn w-10">Cancel</Button>

            <Button className="btn-style save-btn ml-1 w-10" htmlType="submit">
              Save
            </Button>
          </Row> */}
        </Form>
      </Spin>
    </div>
  );
};

export default AddNewRoute;
